export default __webpack_public_path__ + "static/media/elo-corporativo.c64d6cef.svg";